import type { OTCFieldsData } from '@src/types/OTC/otcProductBuilderTypes';
import { compact, uniq } from 'lodash-es';

/** Borrowed + collateral (deduped); shared by fixed- and floating-rate loan OTC dialogs and validation */
export function getAllowedLoanPaymentCcyAssets(
  baseAsset: string | null | undefined,
  collateralAsset: string | null | undefined
): string[] {
  return uniq(compact([baseAsset, collateralAsset]));
}

export function getLoanPaymentCurrencyOptionsForRow(
  baseAsset: string | null | undefined,
  collateralAsset: string | null | undefined
): Array<{ value: string; displayName: string }> {
  return getAllowedLoanPaymentCcyAssets(baseAsset, collateralAsset).map(asset => ({
    value: asset,
    displayName: asset,
  }));
}

export function isAllowedLoanPaymentCcy(
  loanPaymentCcy: string | null | undefined,
  baseAsset: string | null | undefined,
  collateralAsset: string | null | undefined
): boolean {
  return !!loanPaymentCcy && getAllowedLoanPaymentCcyAssets(baseAsset, collateralAsset).includes(loanPaymentCcy);
}

/**
 * For loan OTC dialog init / clear: ensure loan payment currency is borrowed or collateral.
 * If unset or not in [borrowed, collateral], set to borrowed (base asset).
 */
export function withDefaultLoanPaymentCcyFromBorrowedAsset(
  otcFields: OTCFieldsData,
  baseAsset: string | null | undefined,
  collateralAsset: string | null | undefined = undefined
): OTCFieldsData {
  if (!baseAsset) {
    return otcFields;
  }
  if (otcFields.productType !== 'fixedRateLoan' && otcFields.productType !== 'floatingRateLoan') {
    return otcFields;
  }
  if (isAllowedLoanPaymentCcy(otcFields.loanPaymentCcy, baseAsset, collateralAsset)) {
    return otcFields;
  }
  return { ...otcFields, loanPaymentCcy: baseAsset };
}
